// extracted by mini-css-extract-plugin
export default {"title":"Styles_title__lh4Ff","button":"Styles_button__q3cG8","buttonAdd":"Styles_buttonAdd__p6V4P"};